import einhornaloneCollab from "../../assets/images/products/collab/einhornalone_collab.svg"
import einhornaloneIdentity from "../../assets/images/products/identity/einhornalone_identity.svg"
import einhornaloneMail from "../../assets/images/products/mail/einhornalone_mail.svg"
import einhornaloneMeet from "../../assets/images/products/meet/einhornalone_meet.svg"
import { useTranslation } from "../../plugins/i18next/ea-react-i18next";
import { ProductType } from "./ProductList";
import { getNeedsByType, getProductNeedsStatement } from "./ProductNeedsList"

const ProductNeeds: React.FC<{ product: ProductType }> = ({ product }) => {
  const { t } = useTranslation("components", { keyPrefix: 'products.productNeeds' });

  const needsList = getNeedsByType(product);
  const needsHeader = getProductNeedsStatement(product);

  const einhornalone = (product: any): string => {
    switch (product) {
      case ProductType.Collab:
        return einhornaloneCollab;
      case ProductType.Mail:
        return einhornaloneMail;
      case ProductType.Meet:
        return einhornaloneMeet;
        case ProductType.Identity:
          return einhornaloneIdentity;
      default:
        return ""
    }
  }

  return (
    <section className="about-area ptb-70">
      <div className="container-fluid hero-container">
        <div className="product-need">
          <h2>{t(`${needsHeader}`)}</h2>
        </div>
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="about-content">
                <div className="content">
                  <div className="our-mission-image">
                      <img
                        src={einhornalone(product)}
                        alt="image"
                        className="product-mission-image"
                      />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="about-content">
                <div className="content">
                  <ul className="content-list">
                    {needsList.map((item, index) => (
                      <li key={index}>
                        <i className="flaticon-tick"></i> {t(`${item}.title`)}
                        <br />
                        <p>{t(`${item}.details`)}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductNeeds
